/**
 * @generated SignedSource<<32eb2f0fe566fec54db5c38aedc9ffd9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksUsePageTargetingArticle$data = {
  readonly firstTopic: {
    readonly name: string;
  } | null | undefined;
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "hooksUsePageTargetingArticle";
};
export type hooksUsePageTargetingArticle$key = {
  readonly " $data"?: hooksUsePageTargetingArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksUsePageTargetingArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksUsePageTargetingArticle"
};

(node as any).hash = "6a7c0d3969113c8c7a4b495d7370e91c";

export default node;
